<h3 mat-dialog-title>Payment Detail</h3>
<div mat-dialog-content>
    <div class="mb-5">
        <ul class="list-unstyled">
            <li>{{ consult.additional_info.payment.name }}</li>
            <li>Amount: {{ consult.additional_info.payment.price | currency: consult.payment.currency :'symbol':'1.2'}}</li>
            <li>Payment Status: {{ paymentStatus }}</li>
            <!-- <li>Amount Paid: {{ consult.payment.price  | currency: consult.payment.currency :'symbol':'1.2'}}</li> -->
        </ul>
    </div>
</div>

<mat-dialog-actions align="center">
    <button mat-raised-button mat-dialog-close tabindex="-1">Close</button>
</mat-dialog-actions>